import { render, staticRenderFns } from "./GroupListAuth.vue?vue&type=template&id=56841841&scoped=true"
import script from "./GroupListAuth.vue?vue&type=script&lang=js"
export * from "./GroupListAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56841841",
  null
  
)

export default component.exports